import { gql } from '@apollo/client'

export const CREATE_MODEL = gql`
  mutation createModel($input: CreateModelInput!) {
    data: createModel(input: $input) {
      id
    }
  }
`
